import { ToggleEnum, UserType } from 'common/common.types';

export const hasLdToggle = (state: UserType, toggles: ToggleEnum[]): boolean =>
  toggles.some(toggle => toggle in state.ldToggles && state.ldToggles[toggle]);

export default (state: UserType, toggles: ToggleEnum[]): boolean =>
  toggles.some(toggle => toggle in state.toggles);
